"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _formik = require("formik");

var _Media = require("../../Ui/Media");

var _Form = require("../../../domains/registration/onboarding/shared/styles/Form");

var _FileField = require("./FileField.styled");

var _FileNameDisplay = _interopRequireDefault(require("./FileNameDisplay"));

var _FileUpload = _interopRequireDefault(require("./FileUpload"));

var _FileUploadField = require("./FileUploadField.styled");

var __jsx = _react["default"].createElement;

function FileStatus(_ref) {
  var file = _ref.file,
      templateFilename = _ref.templateFilename,
      templateFileUrl = _ref.templateFileUrl;

  if (file) {
    return __jsx(_FileUploadField.FileName, null, __jsx(_FileUploadField.PaperClipIcon, {
      width: "16"
    }), " ", __jsx(_FileNameDisplay["default"], {
      filename: file.name
    }));
  }

  if (templateFilename) {
    return __jsx(_FileUploadField.FileLink, {
      as: "a",
      href: templateFileUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      download: templateFilename
    }, __jsx(_FileUploadField.PaperClipIcon, {
      width: "16"
    }), " Download template");
  }

  return __jsx(_FileUploadField.FileName, null, __jsx(_FileUploadField.PaperClipIcon, {
    width: "16"
  }), "No file selected");
}

var FileUploadField = function FileUploadField(_ref2) {
  var name = _ref2.name,
      label = _ref2.label,
      description = _ref2.description,
      files = _ref2.files,
      _ref2$multiple = _ref2.multiple,
      multiple = _ref2$multiple === void 0 ? false : _ref2$multiple,
      onFilesRemoved = _ref2.onFilesRemoved,
      dataTestid = _ref2['data-testid'],
      templateFilename = _ref2.filename,
      templateFileUrl = _ref2.url;

  var handleFilesSelected = function handleFilesSelected(selectedFiles, setFieldValue) {
    setFieldValue(name, selectedFiles);
  };

  var handleFilesRemoved = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(selectedFiles, setFieldValue) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onFilesRemoved(selectedFiles);

            case 2:
              setFieldValue(name, []);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleFilesRemoved(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return __jsx(_formik.Field, {
    name: name
  }, function (_ref4) {
    var _ref4$meta = _ref4.meta,
        error = _ref4$meta.error,
        touched = _ref4$meta.touched,
        _ref4$meta$value = _ref4$meta.value,
        selectedFilesList = _ref4$meta$value === void 0 ? [] : _ref4$meta$value,
        form = _ref4.form;
    var hasSelectedFile = (selectedFilesList === null || selectedFilesList === void 0 ? void 0 : selectedFilesList.length) > 0;
    var hasSelectedMultipleFiles = multiple && (selectedFilesList === null || selectedFilesList === void 0 ? void 0 : selectedFilesList.length) > 1;
    return __jsx(_FileUploadField.StyledFileUploadField, null, __jsx(_Media.Media, {
      center: true
    }, __jsx(_Media.MediaBody, null, __jsx(_FileUploadField.FieldTitle, null, label, " ", hasSelectedFile && __jsx(_FileUploadField.FileSelectedCheck, null)), description && __jsx(_FileUploadField.FileDescription, null, description), __jsx(_FileUploadField.FileDescription, null, hasSelectedFile ? selectedFilesList.map(function (file, fileIndex) {
      return __jsx(FileStatus, {
        key: fileIndex,
        file: file
      });
    }) : __jsx(FileStatus, {
      templateFilename: templateFilename,
      templateFileUrl: templateFileUrl
    })), multiple && !hasSelectedMultipleFiles && __jsx(_FileUploadField.FileDescription, null, "You may select multiple files at once."), error && touched && __jsx(_FileField.FileError, null, __jsx(_Form.FormFieldError, {
      name: name
    }))), __jsx(_Media.MediaObject, {
      $preserveSize: true
    }, __jsx(_FileUpload["default"], {
      label: "Upload file",
      "aria-label": label,
      files: files,
      multiple: multiple,
      onFilesRemoved: function onFilesRemoved(removedFiles) {
        return handleFilesRemoved(removedFiles, form.setFieldValue);
      },
      onFilesSelected: function onFilesSelected(selectedFiles) {
        return handleFilesSelected(selectedFiles, form.setFieldValue);
      },
      "data-testid": dataTestid
    }))));
  });
};

var _default = FileUploadField;
exports["default"] = _default;